import { ListOfPlanItemResponse } from './ListOfPlanItemResponse';

export class ListOfPlanCalendarResponse {
	employee_id: number;
	employee_name: string;
	info: string;
	workflow_group: number;
	ListOfPlanItem: ListOfPlanItemResponse[];
}
